export default __webpack_public_path__ + "static/media/Services.310357dc.jpeg";